"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var AlertIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M12,3 C7.0294,3 3,7.0292 3,12 C3,16.9708 7.0294,21 12,21 C16.9706,21 21,16.9708 21,12 C21,7.0292 16.9706,3 12,3 Z M12,17.8906 C11.277,17.8906 10.691,17.3046 10.691,16.5816 C10.691,15.8586 11.277,15.2726 12,15.2726 C12.723,15.2726 13.3092,15.8586 13.3092,16.5816 C13.3092,17.3046 12.723,17.8906 12,17.8906 Z M13.421,7.7718 L12.9162,13.7016 C12.9162,14.2076 12.506,14.6178 12,14.6178 C11.494,14.6178 11.0836,14.2076 11.0836,13.7016 L10.579,7.7718 C10.5678,7.6992 10.56,7.6252 10.56,7.549 C10.56,6.7538 11.205,6.1092 12,6.1092 C12.7954,6.1092 13.44,6.7538 13.44,7.549 C13.44,7.6252 13.4324,7.6992 13.421,7.7718 Z" }))); };
exports.AlertIcon = AlertIcon;
